/* Straws Direct theme JS.
   Every feature is wrapped in guard() so a failure in one block can never
   take down another — in particular the cart checkout gate. */
(function(){
  'use strict';

  function guard(name, fn){
    try{ fn(); }catch(err){ if(window.console&&console.error)console.error('[sd] '+name+' failed:', err); }
  }

  /* ---------- VAT display (runs first: other blocks depend on it) ---------- */
  var VAT_KEY='sd-vat-mode', VAT_RATE=1.2;
  function vatMode(){ try{ return localStorage.getItem(VAT_KEY)==='ex' ? 'ex' : 'inc'; }catch(e){ return 'inc'; } }
  function fmtMoney(pence){
    var n=pence/100;
    return '£'+n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
  function displayPence(rawPence){
    var raw=parseFloat(rawPence);
    if(isNaN(raw))return null;
    return vatMode()==='ex' ? Math.round(raw/VAT_RATE) : raw;
  }
  function applyVat(){
    var m=vatMode(), ex=(m==='ex');
    document.querySelectorAll('[data-vat-price]').forEach(function(el){
      var val=displayPence(el.getAttribute('data-vat-price'));
      if(val===null)return;
      var small=el.querySelector('small');
      var text=fmtMoney(val)+(small?' ':'');
      var first=el.firstChild;
      if(first&&first.nodeType===3){ first.nodeValue=text; }
      else if(first){ el.insertBefore(document.createTextNode(text),first); }
      else{ el.textContent=text; }
    });
    document.querySelectorAll('[data-vat-label]').forEach(function(el){
      var upper=el.textContent===el.textContent.toUpperCase();
      el.textContent=upper?(ex?'EX VAT':'INC VAT'):(ex?'ex VAT':'inc VAT');
    });
    document.querySelectorAll('button[data-vat-mode]').forEach(function(b){
      b.classList.toggle('is-on',b.getAttribute('data-vat-mode')===m);
      b.setAttribute('aria-pressed',b.getAttribute('data-vat-mode')===m?'true':'false');
    });
    document.querySelectorAll('[data-vat-note]').forEach(function(el){
      el.textContent=ex?'Prices shown exclude VAT. You are charged the VAT-inclusive price. Delivery calculated at checkout.'
                       :'Includes VAT. Delivery calculated at checkout.';
    });
    document.documentElement.setAttribute('data-vat-mode',m);
    try{ document.dispatchEvent(new CustomEvent('sd:vat',{detail:{mode:m}})); }catch(e){}
  }
  window.SD_VAT_MODE=vatMode;
  window.SD_VAT_APPLY=applyVat;
  window.SD_VAT_FORMAT=function(rawPence){ var v=displayPence(rawPence); return v===null?'':fmtMoney(v); };

  guard('vat-toggle',function(){
    // Only the two toggle buttons may match here. Never widen this selector:
    // matching an ancestor (e.g. <html data-vat-mode>) would preventDefault every click on the site.
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('button[data-vat-mode]');
      if(!b)return;
      try{ localStorage.setItem(VAT_KEY,b.getAttribute('data-vat-mode')); }catch(err){}
      applyVat();
    });
    applyVat();
  });

  /* ---------- cart count ---------- */
  function refreshCartCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count});
    }).catch(function(){});
  }

  /* ---------- cart eligibility declaration (checkout gate) ---------- */
  guard('cart-gate',function(){
    var cartForm=document.querySelector('.sd-cart-form');
    if(!cartForm)return;
    var checkoutBtn=cartForm.querySelector('[data-checkout-btn]');
    if(cartForm.dataset.hasPlastic!=='true'){
      if(checkoutBtn)checkoutBtn.disabled=false;   // paper-only baskets are never gated
      return;
    }
    var check=cartForm.querySelector('[data-declaration-check]');
    var category=cartForm.querySelector('[data-declaration-category]');
    var value=cartForm.querySelector('[data-declaration-value]');
    var gateMsg=cartForm.querySelector('[data-gate-msg]');
    function update(){
      var ok=!!(check&&check.checked&&category&&category.value);
      if(checkoutBtn)checkoutBtn.disabled=!ok;
      if(gateMsg)gateMsg.hidden=ok;
      if(value)value.value=ok?('Confirmed — '+category.value+' — '+new Date().toISOString().slice(0,10)):'';
    }
    if(check)check.addEventListener('change',update);
    if(category)category.addEventListener('change',update);
    update();
  });

  /* ---------- catalogue cards ---------- */
  guard('catalogue-cards',function(){
    document.querySelectorAll('.sd-card').forEach(function(card){
      var title=card.getAttribute('data-title')||'';
      var mm=title.match(/(\d+(?:\.\d+)?)mm/g)||[];
      var boreEl=card.querySelector('[data-bore]'),lenEl=card.querySelector('[data-length]');
      if(boreEl)boreEl.textContent=mm[0]||'—';
      if(lenEl)lenEl.textContent=mm[1]||'—';
      card.dataset.bore=(mm[0]||'').replace('mm','');
      card.dataset.length=(mm[1]||'').replace('mm','');

      var chips=card.querySelectorAll('.sd-chip--variant');
      var priceEl=card.querySelector('.sd-card__price[data-price]');
      var variantLabel=card.querySelector('[data-variant-label]');
      var qtyInput=card.querySelector('[data-qty]');
      var addBtn=card.querySelector('[data-add]');
      var unitEl=card.querySelector('[data-unitprice]');
      var stockEl=card.querySelector('[data-stockline]');
      var current=null;

      function isAvailable(chip){ return chip&&chip.dataset.available!=='false'; }

      function unitPrice(chip){
        if(!unitEl)return;
        var m=(chip&&chip.textContent||'').replace(/,/g,'').match(/(\d{3,})/);
        var raw=chip?parseFloat(chip.dataset.priceRaw):NaN;
        if(m&&!isNaN(raw)){
          var per=displayPence(raw)/parseInt(m[1],10)*1000;
          unitEl.textContent='≈ '+fmtMoney(per)+' per 1,000 straws';
        }else{unitEl.textContent='';}
      }
      function showStock(chip){
        if(!stockEl)return;
        var ok=isAvailable(chip);
        stockEl.textContent=ok?'In stock':'Sold out';
        stockEl.classList.toggle('is-out',!ok);
        if(addBtn){ if(ok){resetAddBtn();addBtn.disabled=false;}else{addBtn.textContent='Sold out';addBtn.disabled=true;} }
      }
      var addBtnHtml=addBtn?addBtn.innerHTML:'';
      function resetAddBtn(){ if(addBtn)addBtn.innerHTML=addBtnHtml; }

      function select(chip){
        chips.forEach(function(c){c.classList.remove('is-active')});
        chip.classList.add('is-active');
        current=chip;
        if(priceEl){
          priceEl.setAttribute('data-vat-price',chip.dataset.priceRaw);
          priceEl.textContent=window.SD_VAT_FORMAT(chip.dataset.priceRaw);
        }
        if(variantLabel)variantLabel.textContent=chip.textContent.trim().toUpperCase();
        unitPrice(chip);
        showStock(chip);
      }

      chips.forEach(function(chip){
        if(!isAvailable(chip)){ chip.classList.add('is-soldout'); chip.title='Sold out'; }
        chip.addEventListener('click',function(){ select(chip); });
      });
      if(chips.length)select(chips[0]);

      document.addEventListener('sd:vat',function(){ unitPrice(current); });

      card.querySelectorAll('[data-step]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var v=parseInt(qtyInput.value||'1',10)+parseInt(btn.dataset.step,10);
          qtyInput.value=Math.max(1,v);
        });
      });

      if(addBtn)addBtn.addEventListener('click',function(){
        if(!current||!isAvailable(current))return;
        addBtn.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(current.dataset.variantId,10),quantity:parseInt(qtyInput.value||'1',10)}]})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){
          addBtn.classList.add('is-added');
          addBtn.innerHTML='&#10003;&nbsp; Added to cart';
          refreshCartCount();
          setTimeout(function(){
            addBtn.classList.remove('is-added');
            resetAddBtn();
            addBtn.disabled=false;
          },1800);
        })
        .catch(function(){addBtn.disabled=false;addBtn.textContent='Try again'});
      });
    });
  });

  /* ---------- filters ---------- */
  guard('filters',function(){
    var cards=[].slice.call(document.querySelectorAll('.sd-card'));
    var typeFilter='all',boreFilter='any',lengthFilter='any';
    function applyFilters(){
      var shown=0;
      cards.forEach(function(card){
        var okType=typeFilter==='all'||(typeFilter==='paper'&&card.classList.contains('is-paper'))||(typeFilter==='plastic'&&card.classList.contains('is-plastic'));
        var okBore=boreFilter==='any'||card.dataset.bore===boreFilter;
        var okLen=lengthFilter==='any'||card.dataset.length===lengthFilter;
        var ok=okType&&okBore&&okLen;
        card.classList.toggle('is-hidden',!ok);
        if(ok)shown++;
      });
      var empty=document.querySelector('[data-filter-empty]');
      if(empty)empty.hidden=shown>0;
    }
    document.querySelectorAll('[data-filter-type]').forEach(function(btn){
      btn.addEventListener('click',function(){
        document.querySelectorAll('[data-filter-type]').forEach(function(b){b.classList.remove('is-active')});
        btn.classList.add('is-active');typeFilter=btn.dataset.filterType;applyFilters();
      });
    });
    document.querySelectorAll('[data-filter-bore]').forEach(function(btn){
      btn.addEventListener('click',function(){
        document.querySelectorAll('[data-filter-bore]').forEach(function(b){b.classList.remove('is-active')});
        btn.classList.add('is-active');boreFilter=btn.dataset.filterBore;applyFilters();
      });
    });
    var lengthRow=document.querySelector('[data-length-filters]');
    if(lengthRow){
      var lengths=[];
      cards.forEach(function(c){
        var l=c.dataset.length;
        if(l&&lengths.indexOf(l)===-1)lengths.push(l);
      });
      lengths.sort(function(a,b){return parseFloat(a)-parseFloat(b)});
      lengths.forEach(function(l){
        var b=document.createElement('button');
        b.type='button';
        b.className='sd-chip sd-chip--length';
        b.setAttribute('data-filter-length',l);
        b.textContent=l+'mm';
        lengthRow.appendChild(b);
      });
      lengthRow.querySelectorAll('[data-filter-length]').forEach(function(btn){
        btn.addEventListener('click',function(){
          lengthRow.querySelectorAll('[data-filter-length]').forEach(function(b){b.classList.remove('is-active')});
          btn.classList.add('is-active');lengthFilter=btn.dataset.filterLength;applyFilters();
        });
      });
    }
    var ca=document.querySelector('[data-count-all]');if(ca)ca.textContent='('+cards.length+')';
    var cp=document.querySelector('[data-count-paper]');if(cp)cp.textContent='('+cards.filter(function(c){return c.classList.contains('is-paper')}).length+')';
    var cl=document.querySelector('[data-count-plastic]');if(cl)cl.textContent='('+cards.filter(function(c){return c.classList.contains('is-plastic')}).length+')';
  });

  /* ---------- quick reorder by SKU ---------- */
  guard('quick-reorder',function(){
    var reorderRows=document.querySelector('[data-reorder-rows]');
    if(!reorderRows)return;
    var addLine=document.querySelector('[data-reorder-add-line]');
    var submit=document.querySelector('[data-reorder-submit]');
    var msg=document.querySelector('[data-reorder-msg]');
    if(!addLine||!submit||!msg)return;
    function bindRemove(row){
      row.querySelector('[data-reorder-remove]').addEventListener('click',function(){
        if(reorderRows.children.length>1)row.remove();
        else{row.querySelector('[data-reorder-sku]').value='';row.querySelector('[data-reorder-qty]').value=1;}
      });
    }
    addLine.addEventListener('click',function(){
      var row=reorderRows.firstElementChild.cloneNode(true);
      row.querySelector('[data-reorder-sku]').value='';
      row.querySelector('[data-reorder-qty]').value=1;
      reorderRows.appendChild(row);bindRemove(row);
      row.querySelector('[data-reorder-sku]').focus();
    });
    [].slice.call(reorderRows.children).forEach(bindRemove);

    submit.addEventListener('click',function(){
      msg.hidden=true;msg.classList.remove('is-error');
      var lines=[].slice.call(reorderRows.querySelectorAll('.sd-reorder-row')).map(function(row){
        return{sku:row.querySelector('[data-reorder-sku]').value.trim().toUpperCase(),qty:Math.max(1,parseInt(row.querySelector('[data-reorder-qty]').value||'1',10))};
      }).filter(function(l){return l.sku});
      if(!lines.length){msg.textContent='Enter at least one SKU code.';msg.classList.add('is-error');msg.hidden=false;return;}
      submit.disabled=true;
      fetch('/products.json?limit=250').then(function(r){return r.json()}).then(function(data){
        var map={};
        data.products.forEach(function(p){p.variants.forEach(function(v){if(v.sku)map[v.sku.toUpperCase()]=v.id})});
        var items=[],unknown=[];
        lines.forEach(function(l){
          var id=map[l.sku];
          if(id)items.push({id:id,quantity:l.qty});else unknown.push(l.sku);
        });
        if(!items.length)throw{unknown:unknown};
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(){return unknown});
      }).then(function(unknown){
        refreshCartCount();
        msg.innerHTML=(unknown&&unknown.length?('Added to basket. Unrecognised SKUs skipped: '+unknown.join(', ')+'. '):'All lines added to your basket. ')+'<a href="/cart">View basket &rarr;</a>';
        msg.hidden=false;submit.disabled=false;
      }).catch(function(e){
        msg.textContent=e&&e.unknown?('No matching SKUs found: '+e.unknown.join(', ')):'Something went wrong — please try again.';
        msg.classList.add('is-error');msg.hidden=false;submit.disabled=false;
      });
    });
  });

  /* ---------- product page ---------- */
  guard('product-page',function(){
    var pdp=document.querySelector('.sd-product-page');
    if(!pdp)return;
    var radios=pdp.querySelectorAll('.sd-chip--radio');
    var pdpPrice=pdp.querySelector('[data-pdp-price]');
    var submitBtn=pdp.querySelector('form[action*="/cart/add"] button[type="submit"]');
    var stockEl=pdp.querySelector('[data-pdp-stock]');
    function selectRadio(label,input){
      radios.forEach(function(l){l.classList.remove('is-active')});
      label.classList.add('is-active');
      if(pdpPrice){
        pdpPrice.setAttribute('data-vat-price',input.dataset.priceRaw);
        applyVat();
      }
      var ok=input.dataset.available!=='false';
      if(submitBtn){ submitBtn.disabled=!ok; submitBtn.textContent=ok?'Add to cart':'Sold out'; }
      if(stockEl){ stockEl.textContent=ok?'In stock':'Sold out'; stockEl.classList.toggle('is-out',!ok); }
    }
    radios.forEach(function(label){
      var input=label.querySelector('input');
      if(!input)return;
      if(input.dataset.available==='false')label.classList.add('is-soldout');
      input.addEventListener('change',function(){ selectRadio(label,input); });
      if(input.checked)selectRadio(label,input);
    });
    pdp.querySelectorAll('[data-step]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var input=pdp.querySelector('input[name="quantity"]');
        input.value=Math.max(1,parseInt(input.value||'1',10)+parseInt(btn.dataset.step,10));
      });
    });
  });

  refreshCartCount();
})();
